// components/Shared/IntroQuiz.js
import React from 'react';
import QuizModal from '../Modules/QuizModal';

const IntroQuiz = ({ 
  isLoading, 
  questions, 
  videoFileName, 
  onComplete 
}) => {
  return (
    <QuizModal
      isLoading={isLoading}
      questions={questions}
      videoFileName={videoFileName}
      onClose={onComplete}
      isIntroQuiz={true}
    />
  );
};

export default IntroQuiz;